import RoutePath from 'App/RoutePath';
import { useSubdomainInfo } from 'LoggedOut/SignUp/useSubdomainInfo';
import useUniversalLogin from 'LoggedOut/UniversalLogin/useUniversalLogin';
import React, { useEffect } from 'react';
import getSubdomainFromUrl from 'utils/getSubdomainFromUrl';
import LoadingIndicator from '../../Shared/LoadingIndicator';

export function MSTeamsSSO() {
  const subdomain = getSubdomainFromUrl();

  const { authProviderOrganisationId, loading } = useSubdomainInfo({
    subdomain,
  });

  const { loginWithUniversalLogin } = useUniversalLogin();

  // The MS Teams SDK is not available in this auth window, so getUserLocale()
  // here would fall back to a default. The outer Teams window forwards the
  // resolved locale via the unmind_locale query param.
  const unmindLocaleOverride =
    new URLSearchParams(window.location.search).get('unmind_locale') ||
    undefined;

  useEffect(() => {
    const redirectToIdentityProvider = async () => {
      await loginWithUniversalLogin({
        authProviderOrganisationId: authProviderOrganisationId,
        returnTo: RoutePath.MSTeamsSSOCallback,
        unmindLocaleOverride,
      });
    };

    if (authProviderOrganisationId) void redirectToIdentityProvider();
  }, [
    authProviderOrganisationId,
    loginWithUniversalLogin,
    unmindLocaleOverride,
  ]);

  if (loading) {
    return <LoadingIndicator />;
  }

  return <></>;
}
